import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Header } from '@/components/layout/Header';

export const Route = createFileRoute('/midoffice')({
	component: MidofficeLayout,
});

function MidofficeLayout() {
	return (
		<>
			<Header />
			<main>
				<Outlet />
			</main>
		</>
	);
}
